import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { UserProfileSettingForm } from "pages/UserSettings";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { countryList } from "../../constants/constants";
import InputFieldWithLabel from "../molecules/forms/InputFieldWithLabel";
import SelectElement from "../molecules/forms/SelectElement";
import { getAndSetStatesForCountry, handleAllowWholeNumberAsInput } from "../../utils/HelperFunctions";

function UserAddressForm() {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<UserProfileSettingForm>();

  const [availableStateOptions, setAvailableStatesOptions] = useState<string[]>([]);
  const [stateOptionsLoading, setStateOptionsLoading] = useState(false);

  const selectedCountry = watch("country");
  const selectedState = watch("state");
  // Fetch states for a given country.
  useEffect(() => {
    if (selectedCountry) {
      getAndSetStatesForCountry(selectedCountry, setStateOptionsLoading, setAvailableStatesOptions);
    }
  }, [selectedCountry]);

  return (
    <div className=" flex flex-col">
      <div className="text-tertiary mt-4 flex items-start font-satoshi text-xs font-semibold md:items-center">
        <InformationCircleIcon className="mr-2 h-6 w-6 text-secondary" />
        <div className="min-h-fit w-1/2 text-base font-450 text-secondary">
          This information will be pre populated for any offers from
          <br />
          Brands that require your address, for eg. merch drops.
        </div>
      </div>
      <div className="mt-4 grid grid-cols-10 gap-x-4  gap-y-0 md:gap-x-12">
        <div className="col-span-10  md:col-span-5">
          <InputFieldWithLabel
            labelClasses="text-base sm:text-base xxl:text-xxs "
            additionalClasses="text-xxs sm:text-xxs xxl:text-xs"
            register={register}
            label="Address Line 1"
            id="address_line1"
            placeHolder="Enter Street Address"
            errorMessage={errors.address_line1?.message}
          />
        </div>
        <div className=" col-span-10 md:col-span-5">
          <InputFieldWithLabel
            labelClasses="text-base sm:text-base xxl:text-xxs "
            additionalClasses="text-xxs sm:text-xxs xxl:text-xs"
            register={register}
            label="Address Line 2"
            id="address_line2"
            placeHolder="Enter Other Applicable Information"
            errorMessage={errors.address_line2?.message}
          />
        </div>

        <div className="col-span-10  md:col-span-5">
          <SelectElement
            labelClasses="text-base sm:text-base xxl:text-xxs "
            additionalClasses="text-xxs sm:text-xxs xxl:text-xs"
            label="Country"
            id="country"
            register={register}
            placeHolder="Select Country"
            selectedValue={selectedCountry}
            errorMessage={errors.country?.message}
            options={countryList}
            isCountrySelector
            optionsLoading={false}
          />
        </div>
        <div className=" col-span-10 md:col-span-5">
          <SelectElement
            labelClasses="text-base sm:text-base xxl:text-xxs "
            additionalClasses="text-xxs sm:text-xxs xxl:text-xs"
            label="State"
            id="state"
            register={register}
            placeHolder="Select State or Province"
            selectedValue={selectedState}
            errorMessage={errors.state?.message}
            options={availableStateOptions || []}
            optionsLoading={stateOptionsLoading}
          />
        </div>
        <div className=" col-span-10 md:col-span-5">
          <InputFieldWithLabel
            labelClasses="text-base sm:text-base xxl:text-xxs "
            additionalClasses="text-xxs sm:text-xxs xxl:text-xs"
            register={register}
            label="City"
            id="city"
            placeHolder="Enter City"
            errorMessage={errors.city?.message}
          />
        </div>
        <div className=" col-span-10 md:col-span-5">
          <InputFieldWithLabel
            labelClasses="text-base sm:text-base xxl:text-xxs "
            additionalClasses="text-xxs sm:text-xxs xxl:text-xs"
            register={register}
            label="Zip Code"
            id="zipcode"
            placeHolder="Enter Zip Code"
            handleOnKeyDown={(e) => handleAllowWholeNumberAsInput(e, true)}
            errorMessage={errors.zipcode?.message}
          />
        </div>
      </div>
    </div>
  );
}
export default UserAddressForm;
